import React from 'react';
import PropTypes from 'prop-types';
import { Badge as ToolkitBadge } from '@quantum-ecosystem/ui-toolkit';

const mapMantineColorToVariant = (color, variant) => {
	if (!color) {
		if (variant === 'light' || variant === 'outline') return 'secondary';
		return 'primary';
	}
	const c = String(color).toLowerCase();
	if (['green', 'teal', 'lime'].includes(c)) return 'success';
	if (['red', 'pink', 'rose'].includes(c)) return 'danger';
	if (['yellow', 'orange', 'amber'].includes(c)) return 'warning';
	if (['blue', 'cyan', 'sky', 'indigo'].includes(c)) return 'info';
	if (['violet', 'purple', 'grape'].includes(c)) return 'primary';
	if (['gray', 'grey', 'dark'].includes(c)) return 'secondary';
	return 'primary';
};

const FormBadge = ({
	color,
	variant,
	size,
	radius,
	tt,
	pill = false,
	leftSection,
	rightSection,
	style,
	className = '',
	children,
	...props
}) => {
	const resolvedVariant = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'muted'].includes(variant)
		? variant
		: mapMantineColorToVariant(color, variant);

	const isPill = pill || radius === 'xl' || radius === 'full';

	const computedStyle = {
		textTransform: tt,
		...(style ?? {}),
	};

	return (
		<ToolkitBadge
			variant={resolvedVariant}
			pill={isPill}
			className={className}
			style={computedStyle}
			{...props}
		>
			{leftSection && <span style={{ marginRight: 4, display: 'inline-flex', alignItems: 'center' }}>{leftSection}</span>}
			{children}
			{rightSection && <span style={{ marginLeft: 4, display: 'inline-flex', alignItems: 'center' }}>{rightSection}</span>}
		</ToolkitBadge>
	);
};

FormBadge.propTypes = {
	color: PropTypes.string,
	variant: PropTypes.string,
	size: PropTypes.string,
	radius: PropTypes.string,
	tt: PropTypes.string,
	pill: PropTypes.bool,
	leftSection: PropTypes.node,
	rightSection: PropTypes.node,
	style: PropTypes.object,
	className: PropTypes.string,
	children: PropTypes.node,
};

export default FormBadge;
